import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import owlLogo from '../../Assets/logo icon transparent background.png';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="w-full bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
        <header className="container mx-auto px-4 flex justify-between items-center py-5">
          <Link to="/" className="flex items-center">
            <img src={owlLogo} alt="SuperOwl Logo" className="h-14 md:h-16 mr-3" />
            <span className="text-[#1d2840] text-2xl md:text-3xl font-bold">Super</span>
            <span className="text-[#3DA3DC] text-2xl md:text-3xl font-bold">Owl</span>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            <Link to="/about" className="text-gray-700 hover:text-[#3DA3DC] transition-colors">About Us</Link>
            <Link to="/features" className="text-gray-700 hover:text-[#3DA3DC] transition-colors">Features</Link>
            <Link to="/pricing" className="text-gray-700 hover:text-[#3DA3DC] transition-colors">Pricing</Link>
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-[#3DA3DC] transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </header>

        {/* Mobile Navigation */}
        <div className={`
          md:hidden absolute w-full bg-white border-b border-gray-200 
          transition-all duration-200 ease-in-out z-40
          ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
        `}>
          <nav className="container mx-auto px-4 py-2 flex flex-col space-y-2">
            <Link 
              to="/about" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-4 py-2 text-gray-700 hover:text-[#3DA3DC] hover:bg-gray-50 rounded-md transition-colors"
            >
              About Us
            </Link>
            <Link 
              to="/features" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-4 py-2 text-gray-700 hover:text-[#3DA3DC] hover:bg-gray-50 rounded-md transition-colors"
            >
              Features
            </Link>
            <Link 
              to="/pricing" 
              onClick={() => setIsMobileMenuOpen(false)}
              className="px-4 py-2 text-gray-700 hover:text-[#3DA3DC] hover:bg-gray-50 rounded-md transition-colors"
            >
              Pricing
            </Link>
          </nav>
        </div>
      </div>

      {/* Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black bg-opacity-20 z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Navigation;
